import { createContext, useContext } from "react";

 export const CRMContext = createContext(null);
 
 export function useCRMContext() {
  return useContext(CRMContext);
}